exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bkDetails .btn1[data-v-a451b716],.bkDetails .btn2[data-v-a451b716]{color:#fff;background:gray;border-radius:0;padding:0 8px;padding-bottom:4px}.bkDetails .btn1 span[data-v-a451b716],.bkDetails .btn2 span[data-v-a451b716]{display:block;line-height:18px;text-align:right}.bkImage[data-v-a451b716]{padding:0 0 0 14px}.bkImage img[data-v-a451b716]{width:100%}.bkImage .btn[data-v-a451b716]{border-radius:0;background:#000!important;margin:0 auto;padding:5px 25px;display:block}.bold[data-v-a451b716]{font-weight:700}table[data-v-a451b716]{font-size:12px}@media (max-width:576px){.bkImage img[data-v-a451b716]{margin:0 auto;display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a451b716","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/overall_layouts/book-details.vue
// module id = 642
// module chunks = 0